<template>
	<v-container class="mt-4 px-5" fluid>
	  <v-row justify="center"> 
	  	<v-col cols="12" sm="8" md="6">
			<!--ICONO DE AVATAR-->
	  		<v-card class="mx-auto px-4 mb-n16  transparent elevation-0 " align="center" style="z-index: 1;">
          <v-avatar size="180" color="transparent">
				   	<avataaars ></avataaars>
          </v-avatar>
          
				<!-- <v-btn absolute bottom color="primary" small @click="avatarParamentro.editar = true" fab class="text-capitalize mb-4">
					<v-icon small>mdi-pencil</v-icon>
				</v-btn> -->
			</v-card>

			<!--INFO USUARIO-->
			<v-card  class="shadowCard  separacionAlta text-center pb-4">
				<div>
					<div class="mb-0 font-weight-bold colorCurso text-body-1" >
						<strong>{{ getdatosUsuario.nomuser }}</strong>
					</div>

					<p class="mb-0 font-weight-bold">
						<strong>{{ getdatosUsuario.email }}</strong>
					</p>
				</div>
				<v-divider class="ma-0 mt-4 mb-6"></v-divider>
				<br>
				<div v-if="datosPersonales">
					<!-- <label class="grey--text">Nombre completo</label>
					<br/>
					<b class="text-subtitle-1">{{ getdatosUsuario.nomuser }}</b>

					<br/> <br/> -->

					<label class="grey--text">Departamento</label>
					<br/>
					<b class="text-subtitle-1">{{ datosPersonales.departamento }}</b>

					<br/> <br/>

					<label class="grey--text">Puesto</label>
					<br/>
					<b class="text-subtitle-1">{{ datosPersonales.puesto }}</b>

					<br/> <br/>

					<!-- <label class="grey--text">Enfoque</label>
					<br/>
					<b class="text-subtitle-1">{{ datosPersonales.telefono1 }}</b>

					<br/> <br/>
					
					<label class="grey--text">Responsabilidades</label>
					<br/>
					<b class="text-subtitle-1">{{ datosPersonales.ciclo }}</b>

					<br/> <br/> -->

					<label class="grey--text">Antigüedad</label>
					<br/>
					<b class="text-subtitle-1">{{ datosPersonales.anios }} Años, {{ datosPersonales.meses }} Meses, {{ datosPersonales.dias }} Días </b>

					<br/> <br/>

					<label class="grey--text">Horario Laboral</label>
					<br/>
					<b class="text-subtitle-1">{{ datosPersonales.hora_ingreso }} a {{ datosPersonales.hora_salida }} </b>
					<br/> <br/>

					<label class="grey--text">Horario De comida</label>
					<br/>
					<b class="text-subtitle-1">{{ datosPersonales.hora_ingreso_fin }} a {{ datosPersonales.hora_salida_fin }} </b>
					<br/><br/>

					<!-- <label class="grey--text">Descanso</label>
					<br/>
					<b class="text-subtitle-1" v-if="datosPersonales.dia_descanso == 1"> Lunes </b>
					<b class="text-subtitle-1" v-if="datosPersonales.dia_descanso == 2"> Martes </b>
					<b class="text-subtitle-1" v-if="datosPersonales.dia_descanso == 3"> Miércoles </b>
					<b class="text-subtitle-1" v-if="datosPersonales.dia_descanso == 4"> Jueves </b>
					<b class="text-subtitle-1" v-if="datosPersonales.dia_descanso == 5"> Viernes </b>
					<b class="text-subtitle-1" v-if="datosPersonales.dia_descanso == 6"> Sábado </b>
					<b class="text-subtitle-1" v-if="datosPersonales.dia_descanso == 7"> Domingo </b>
					<br/><br> -->
				</div>
			</v-card>
	  	</v-col>
	  </v-row>

		
	<!-- Dialog de carga -->
	<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
	<carga                v-if="cargar"/>

  	</v-container>
</template>
<script>
	import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

	import Avataaars from 'vuejs-avataaars'

  export default {
  	components:{
  		Avataaars,
  		Alerta,
			carga
  	},

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
			// revisar para que sirve cada dato
			avatar:'',
			datosPersonales: null
    }),

    computed:{
    	...mapGetters( 'login', [ 'getdatosUsuario']),

		},

    created() {
    	console.log( this.getdatosUsuario  )
    	this.initialize()
    },

    methods: {
    	
    	initialize( ){
				// Vaciamos todo
				this.cargar = true
				this.datosPersonales = null
				// Consultamos
				this.$http.get('datos.personales/' + this.getdatosUsuario.id ).then(response=>{
					this.cargar = false
					this.datosPersonales = response.body   	
				}).catch( error =>{
					this.validarError( error )
				}).finally( () => { 
				
    		})
		
			},
  	}
  }
</script>
<style scoped>
	.separacionAlta{
		padding-top: 100px !important;
		padding-left: 10px !important;
		padding-right: 10px !important;
	}

	.bordesCard{
		border-radius: 14px !important;
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

	.cardUsuario{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

  .colorCurso{
  	color:  #5b5b5b;
  }
</style>

